export const LOAD_SMART_LINKS = 'LOAD_SMART_LINKS';
